import { Primitive } from 'utility-types';
import { make, nodeEvaluator } from './node';
import { PolishGenerator, PolishNotation } from './polish';
import Tokenizer from './tokenizer';

export class ExpressionsParser {
  public readonly expression: string;

  constructor(expression: string) {
    this.expression = expression;
  }

  public parse(literalResolver: (literal: string) => Primitive): boolean {
    const tokens = Tokenizer(this.expression);
    const polish = PolishNotation(tokens);
    const gen = PolishGenerator(polish);
    // @ts-ignore
    return nodeEvaluator(make(gen), literalResolver);
  }
}
